import { Link, useParams } from 'react-router-dom'
import { Icon, PageHeader } from '@carrent/ui'
import { useKbTree } from '@carrent/domain'

/**
 * Статьи раздела.
 *
 * Закреплённые идут первыми: это то, что перечитывают чаще всего —
 * порядок действий при ДТП, правила фотофиксации.
 *
 * Дерево не раскрывается прямо здесь: на телефоне вложенные списки
 * с треугольниками неудобны. Вместо этого показываются статьи верхнего
 * уровня, а вложенные открываются со страницы родителя — один экран,
 * одно решение.
 */
export default function KbSpacePage() {
  const { spaceKey } = useParams()
  const { space, tree, loading, error } = useKbTree(spaceKey)

  const pinned = tree.filter((p) => p.pinned)
  const rest = tree.filter((p) => !p.pinned)

  return (
    <div className="p-page flex-col gap">
      <PageHeader title={space?.name || 'Раздел'} backTo="/kb" />

      {loading && <div className="kb-m__loading"><div className="spinner" /></div>}

      {error && (
        <div className="kb-m__state">
          <Icon name="warning" size={28} aria-hidden="true" />
          <p className="kb-m__state-title">{error}</p>
        </div>
      )}

      {!loading && !error && tree.length === 0 && (
        <div className="kb-m__state">
          <Icon name="file" size={28} aria-hidden="true" />
          <p className="kb-m__state-title">В разделе пока пусто</p>
          <p className="kb-m__state-hint">Инструкции появятся здесь, когда их опубликуют.</p>
        </div>
      )}

      {pinned.length > 0 && (
        <section>
          <h2 className="kb-m__section">Важное</h2>
          <ArticleList pages={pinned} spaceKey={spaceKey} />
        </section>
      )}

      {rest.length > 0 && (
        <section>
          {pinned.length > 0 && <h2 className="kb-m__section">Остальное</h2>}
          <ArticleList pages={rest} spaceKey={spaceKey} />
        </section>
      )}
    </div>
  )
}

export function ArticleList({ pages, spaceKey }) {
  return (
    <nav className="more-list" aria-label="Статьи">
      {pages.map((p) => (
        <Link key={p.id} to={`/kb/${spaceKey}/${p.id}`} className="more-list__item">
          <span className="more-list__text">
            <span className="more-list__label">{p.title}</span>
            {p.children?.length > 0 && (
              <span className="more-list__hint">
                {p.children.length} {plural(p.children.length)} внутри
              </span>
            )}
          </span>
          <Icon name="chevronRight" size={18} className="more-list__chevron" />
        </Link>
      ))}
    </nav>
  )
}

function plural(n) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return 'статья'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'статьи'
  return 'статей'
}
